// src/utils/constants.ts
var defaultOldEventTimeLimit = 14 * 24 * 60 * 60 * 1e3;
var defaultMutexLockTimeout = 5e3;
var defaultAllowExternalInstallId = true;
var defaultSessionExpiration = 3e5;
var INSTALLATION_ID_KEY = "__yvii";

export {
  defaultOldEventTimeLimit,
  defaultMutexLockTimeout,
  defaultAllowExternalInstallId,
  defaultSessionExpiration,
  INSTALLATION_ID_KEY
};
